import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { Users, Heart, Target, Newspaper, ExternalLink, ArrowRight, ShieldCheck } from 'lucide-react';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
export function BDE() {
  return <div className="flex flex-col w-full" data-id="element-632" data-mp="1gx4q65wnxof3">
      <PageHeader title="Le BDE Zillenium" subtitle="Un bureau des étudiants engagé, formateur et fédérateur. Découvrez une vie étudiante dynamique et solidaire." data-id="element-633" data-mp="1luwiv254tekc" />

      <div className="flex flex-col w-full" data-id="element-634" data-mp="1buvxlanpcodi">
        {/* Intro & Projets */}
        <section className="py-24 bg-muted relative overflow-hidden" data-id="element-635" data-mp="31avbt666h400">
          <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-636" data-mp="318iwl0rt17qn" />
          <div className="container max-w-6xl mx-auto relative z-10" data-id="element-637" data-mp="3rucd93gx9xvh">
            <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-638" data-mp="3mvsmmprdvxws">
              <SectionHeading title="Association BDE Zillenium" centered className="mb-6" data-id="element-639" data-mp="3mv9cvwbw0ftu" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-8" data-id="element-640" data-mp="foev6rtz5u1">
                Le Bureau des Étudiants est un espace clé de la vie étudiante.
                Il permet aux apprenants de se rencontrer, de s'engager et de
                construire ensemble des projets concrets qui développent
                l'esprit d'équipe, la prise d'initiative et le sens des
                responsabilités.
              </p>
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 inline-block text-left" data-id="element-641" data-mp="3dub6j7dz7w83">
                <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-4" data-id="element-642" data-mp="x4nooq82cfoc">
                  Des projets incroyables se préparent :
                </h3>
                <div className="flex flex-wrap gap-3 justify-center sm:justify-start" data-id="element-643" data-mp="3lyapqxn49br3">
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-644" data-mp="3qxnke4k8bn48">
                    Maraude solidaire
                  </Badge>
                  <Badge className="bg-primary text-white hover:bg-primary-dark border-none px-4 py-2 text-sm" data-id="element-645" data-mp="3th7irmweqs5">
                    Tournoi inter-écoles
                  </Badge>
                  <Badge className="bg-primary-dark text-white hover:bg-primary border-none px-4 py-2 text-sm" data-id="element-646" data-mp="3371ccda862u8">
                    Sensibilisation au don du sang
                  </Badge>
                  <Badge className="bg-brand-orange text-white hover:bg-[#E67E22] border-none px-4 py-2 text-sm" data-id="element-647" data-mp="3c7g0dkekpw1f">
                    Bal de promo
                  </Badge>
                </div>
              </div>
            </div>

            {/* Association loi 1901 */}
            <div className="max-w-3xl mx-auto mb-20" data-id="element-648" data-mp="2oinb26sgimfs">
              <Card className="border-none shadow-md bg-white overflow-hidden" data-id="element-649" data-mp="2h072kxw8aj0y">
                <div className="h-1.5 w-full bg-primary" data-id="element-650" data-mp="2gy2yofybxk0o" />
                <CardContent className="p-6 sm:p-8 flex flex-col sm:flex-row items-start gap-5" data-id="element-651" data-mp="2c2nn5unso07f">
                  <div className="w-12 h-12 shrink-0 bg-lavande rounded-xl flex items-center justify-center" data-id="element-652" data-mp="27yfwvt1ouc73">
                    <ShieldCheck className="w-6 h-6 text-primary" data-id="element-653" data-mp="230605e0bf3jd" />
                  </div>
                  <div data-id="element-654" data-mp="1y2cwarmhilm9">
                    <h3 className="font-bold text-lg text-primary-dark mb-2" data-id="element-655" data-mp="1y3nywo471nbs">
                      Association déclarée sous la loi 1901
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-sm" data-id="element-656" data-mp="1octbvhj4ijpa">
                      Le Bureau des Étudiants de Zillenium est une association
                      régie par la loi du 1<sup data-id="element-657" data-mp="1fbd1vaw80jll">er</sup> juillet 1901, déclarée
                      à la sous-préfecture de Sens.
                    </p>
                    <div className="flex flex-wrap gap-x-8 gap-y-2 mt-4 text-sm" data-id="element-658" data-mp="1acijub62uz2j">
                      <span data-id="element-659" data-mp="3afb5wyvzevrl">
                        <span className="text-muted-foreground" data-id="element-660" data-mp="3agcqpv2suwmi">N° RNA : </span>
                        <span className="font-semibold text-primary-dark" data-id="element-661" data-mp="3fctdoly9j4y0">
                          W893007506
                        </span>
                      </span>
                      <span data-id="element-662" data-mp="35mrqdwdqhqk5">
                        <span className="text-muted-foreground" data-id="element-663" data-mp="35lyslkwr6be5">
                          Siège social :{' '}
                        </span>
                        <span className="font-semibold text-primary-dark" data-id="element-664" data-mp="2vpdlmu16aq7o">
                          25 rue Gabriel Cortel, 89300 Joigny
                        </span>
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-665" data-mp="fyhcvodfft54">
              <Card className="border-none shadow-xl bg-primary text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-666" data-mp="fw4uja3rbgrj">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-667" data-mp="25etm4lurmirs">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-668" data-mp="20gidufk4cgbo">
                    <Users className="w-8 h-8 text-lavande animate-soft-bounce" data-id="element-669" data-mp="2f7943j62b7co" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-670" data-mp="2acd3vvqo9doh">
                    SE RETROUVER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-671" data-mp="2j79hr1lc7eio">
                    Des actions solidaires et citoyennes portées par les
                    étudiants
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-brand-orange text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-672" data-mp="2t5gxjh3w3qj3">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-673" data-mp="yqwipl292p7m">
                  <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-674" data-mp="1of1vwbwx1ti8">
                    <Heart className="w-8 h-8 text-white animate-soft-pulse" data-id="element-675" data-mp="1sh5jfywv0ojv" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-676" data-mp="1xe5j9s348v2j">
                    S'AMUSER
                  </h3>
                  <p className="text-white/90 leading-relaxed" data-id="element-677" data-mp="22cgsq1pi13k8">
                    Une vie étudiante dynamique, conviviale et engagée
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl bg-primary-dark text-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-678" data-mp="2g67ycz0403ao">
                <CardContent className="p-8 text-center flex flex-col items-center h-full" data-id="element-679" data-mp="2l3zrtxgejxgz">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-680" data-mp="2q5gpzl7i55tv">
                    <Target className="w-8 h-8 text-lavande animate-soft-float" data-id="element-681" data-mp="jfvkkc03bcfv" />
                  </div>
                  <h3 className="font-extrabold font-heading text-xl mb-4" data-id="element-682" data-mp="ehbvi2q79kja">
                    CRÉER
                  </h3>
                  <p className="text-lavande leading-relaxed" data-id="element-683" data-mp="9j0n7wfjzi36">
                    Des projets associatifs concrets, de la conception à la
                    réalisation
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* BDE Press Article */}
            <div className="mb-16" data-id="element-684" data-mp="x8l66fbpifcg">
              <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-white" data-id="element-685" data-mp="x9mv9npk52d6">
                <div className="h-2 w-full bg-brand-orange" data-id="element-686" data-mp="nhqnfkxo5xvr" />
                <CardContent className="p-8 sm:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-687" data-mp="nhgt5l5ld4k9">
                  <div className="w-20 h-20 shrink-0 bg-brand-orange/10 rounded-2xl flex items-center justify-center" data-id="element-688" data-mp="1kyfi8uo7bzvn">
                    <Newspaper className="w-10 h-10 text-brand-orange" data-id="element-689" data-mp="1g4l0hws5puz7" />
                  </div>
                  <div className="flex-1 text-center md:text-left" data-id="element-690" data-mp="oh05ep4hx69o">
                    <Badge className="bg-slate-100 text-slate-600 hover:bg-slate-200 border-none mb-4" data-id="element-691" data-mp="tb4djbphzkcc">
                      Dans la presse • L'Yonne Républicaine
                    </Badge>
                    <h3 className="font-bold text-xl md:text-2xl text-primary-dark mb-4 leading-tight" data-id="element-692" data-mp="ki15xk1ja1pm">
                      À Joigny, les étudiants lancent des journées de partage
                      pour redynamiser La Madeleine et lutter contre la
                      précarité étudiante
                    </h3>
                    <p className="text-muted-foreground mb-6" data-id="element-693" data-mp="y8ee9nic7ifh">
                      Une belle mise en lumière de l'engagement de nos étudiants
                      et du BDE Zillenium dans la presse locale.
                    </p>
                    <Button asChild variant="outline" className="group border-slate-200 hover:border-brand-orange hover:text-brand-orange" data-id="element-694" data-mp="3nxooy22wywgo">
                      <a href="https://www.lyonne.fr/joigny-89300/actualites/pour-redynamiser-la-madeleine-et-lutter-contre-la-precarite-des-etudiants-vont-initier-des-journees-de-partage-a-joigny_14964196/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2" data-id="element-695" data-mp="3bg5ly2oc0584">
                        Lire l'article complet
                        <ExternalLink className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-696" data-mp="2sn1o0542z67p" />
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* BDE Video Gallery */}
            <div className="mb-16" data-id="element-697" data-mp="2915anzd00uh1">
              <SectionHeading title="La vie du BDE en images" centered className="mb-10" data-id="element-698" data-mp="28zu45rs658m8" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-699" data-mp="1a6yfkd4mreok">
                {['https://www.instagram.com/reel/DbfjvGXOCvH/embed', 'https://www.instagram.com/reel/DbgRvI4t3t0/embed', 'https://www.instagram.com/p/DbbFE78jUEc/embed', 'https://www.instagram.com/reel/DZ0K5pFNFOZ/embed', 'https://www.instagram.com/reel/DZsokh-OUor/embed', 'https://www.instagram.com/p/DZrtdYhIr7B/embed', 'https://www.instagram.com/p/DZPobROjY_C/embed', 'https://www.instagram.com/reel/DY7lQJ5uSwb/embed', 'https://www.instagram.com/reel/DY5HdDCO9pL/embed'].map((url, i) => <div key={i} className="bg-white p-3 rounded-[2rem] shadow-lg border border-slate-100 hover:-translate-y-1 hover:shadow-xl transition-all duration-300" data-id="element-700" data-mp="dg609hpitqnu" data-mpi={i}>
                    <div className="relative rounded-[1.5rem] overflow-hidden bg-slate-100 aspect-[9/16]" data-id="element-701" data-mp="2k7ap2qdvyb7u">
                      <iframe src={url} title={`Vidéo BDE ${i + 1}`} className="absolute inset-0 w-full h-full" frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-702" data-mp="2t5mit1a1tp4i"></iframe>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-703" data-mp="2aed1i5u1dw2d">
              <Button size="lg" className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl w-full sm:w-auto" asChild data-id="element-704" data-mp="2f7fvgf2q77j3">
                <a href="https://www.instagram.com/bdezillenium/" target="_blank" rel="noopener noreferrer" data-id="element-705" data-mp="1mnzdcqekohd2">
                  Suivre le BDE sur Instagram
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* CTA Candidater */}
        <section className="py-24 bg-primary-dark text-white relative overflow-hidden" data-id="element-706" data-mp="2urg2zoqwdieo">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-40 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-707" data-mp="271lrbaibdzw0" />
          <div className="container text-center max-w-4xl mx-auto relative z-10" data-id="element-708" data-mp="224lpjbshzjap">
            <h2 className="font-heading text-4xl md:text-5xl font-extrabold mb-8 tracking-tight" data-id="element-709" data-mp="2g3v3e4t8e1bi">
              Envie de rejoindre l'aventure ?
            </h2>
            <p className="text-lavande text-xl mb-12 leading-relaxed font-medium" data-id="element-710" data-mp="3rgxhmt7uyesi">
              Intégrez une école dynamique où l'alternance rime avec engagement,
              solidarité et réussite.
            </p>
            <Button size="lg" className="bg-white hover:bg-lavande text-primary-dark text-lg px-10 py-7 shadow-xl group" asChild data-id="element-711" data-mp="3uyblt6vbbfyi">
              <Link to="/candidater" className="flex items-center" data-id="element-712" data-mp="3l205m5slq5ys">
                Candidater maintenant
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-713" data-mp="3q1cqikzwx2yq" />
              </Link>
            </Button>
          </div>
        </section>
      </div>
    </div>;
}